import {Pipe, PipeTransform} from '@angular/core';
import {Column, TableService} from 'app/shared/service/table.service';

/**
 * Renvoie le champ d'un élément sous forme de string.
 */
@Pipe({name: 'elementFieldAsString'})
export class ElementFieldStringPipe implements PipeTransform {

    constructor(public tableService: TableService) {
    }

    transform(element: any, column: Column): string {
        return this.tableService.getFieldValueAsString(element, column);
    }
}
